import { memo } from "react";
import styled from "styled-components";

import { LastUpdatedInfo } from "common/types/LastUpdatedInfo";
import { getDateAndTimeString } from "utils/DateTools";

type Props = {
  lastUpdated?: LastUpdatedInfo;
  className?: string;
};

const LastUpdatedCtrl = memo((props: Props) => {
  const { lastUpdated, className } = props;

  return (
    <SDiv className={`${className}`}>
      {!lastUpdated ? (
        <label>新規登録</label>
      ) : (
        <>
          <label>最終更新:</label>
          {lastUpdated.savedByApp && <label> (アプリ) </label>}
          <label>{`${getDateAndTimeString(new Date(lastUpdated.date))} by ${
            lastUpdated.name
          }`}</label>
        </>
      )}
    </SDiv>
  );
});

export default LastUpdatedCtrl;

const SDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
  font-size: 12px;
`;
